import * as marietta from '../../..';
import { Dialog } from '../../../core/view';
import { BUILDING_TYPE_HOUSE, BUILDING_TYPE_MANSION } from '../../Constants';
/**
 * グレード選択ダイアログ
 */
class GradeTypeSelectDialog extends Dialog {
  public callBack:Function;

  /**
   * コンストラクタ
   */
  constructor(draggable: boolean) {
    super(draggable);

    // ダイアログのコンテンツ生成
    const id = 'gradeTypeSelectDialog';
    // タイトル
    let title = '建築物の選択';
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'jp': title = 'グレードの選択'; break;
      default: title = 'Grade Select'; break;
    }

    let contents = '<div class="selectBody">';
    contents += '<div class="selectTitle"><span class="jp">グレードを選択してください</span>';
    contents += '<span class="en">Select the grade you want to set all your items at.</span></div>';
    contents += '<select id="gradeSelectList">';
    for (let i:number = 0; i < marietta.webcad.WebCADGlobal.masterManager.GRADES.length; i++ ) {
      let selectedGrade = '';
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.grade) {
        const gradeId = marietta.webcad.WebCADGlobal.webcad2Dmanager.grade.id;
        if (gradeId === marietta.webcad.WebCADGlobal.masterManager.GRADES[i].id) {
          selectedGrade = 'selected="selected"';
        }
      }
      contents += '<option value="' + marietta.webcad.WebCADGlobal.masterManager.GRADES[i].id + '"' +selectedGrade+'>' +  marietta.webcad.WebCADGlobal.masterManager.GRADES[i].name + '</option>';
    }
    contents += '</select>';
    contents += '</div>';
    //グレード
    if( !marietta.webcad.WebCADGlobal.masterManager.GRADES || marietta.webcad.WebCADGlobal.masterManager.GRADES.length < 1 ){
      contents += '<p class="dialogInlineError"><span class="jp">※グレードが設定されていません。<br>管理者にお問い合わせください。</span><span class="en\'>*Grade setting is not complete.<br>Please consult with the system admin.</span></p>';
    }

    const footer = '<button id="btnOK"><span class="jp">OK</span><span class="en">OK</span></button>';
    this.createDialog(id, title, contents, footer);

    document.getElementById('btnOK').addEventListener('click', this.btnEventHandler);
  }

  /**
   * モードボタンが押された
   */
  btnEventHandler = (e) => {
    e.preventDefault();

    // 建築モードの更新
    const selectedGrade:string = (<HTMLSelectElement>document.getElementById('gradeSelectList')).value;
    if( !selectedGrade ){
      marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('ALERT_SELECT_GRADE'))
      return;
    }

    if( !marietta.webcad.WebCADGlobal.masterManager.getGradeInfoById( selectedGrade ) ){
      marietta.webcad.WebCADGlobal.showAlert("グレードを選択してください");
      return;
    }

    //グレード毎のアイテムリスト
    const self:GradeTypeSelectDialog = this;
    const p = new Promise((resolve: Function) => {
      marietta.webcad.WebCADGlobal.showBusy(marietta.webcad.collection.WebCADMessages.getText('BUSY_PREPARING_DATA'));
      marietta.webcad.WebCADGlobal.masterManager.getGradeItemMasterData( marietta.webcad.WebCADGlobal.masterManager.getGradeInfoById( selectedGrade ).id, resolve);
    });
    p.then(( list:any[] = null ) => {
      marietta.webcad.WebCADGlobal.hideBusy();
      if( self.callBack ) self.callBack( marietta.webcad.WebCADGlobal.masterManager.getGradeInfoById( selectedGrade ), list );
    });

    this.close();
  }
}

export default GradeTypeSelectDialog;
